import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { FEATURE_ROUTES } from '../routeConstants';

export const LegalFooter: React.FC = () => {
  return (
    <footer className="bg-ninpo-black/90 border-t border-white/5 py-6">
      <div className="max-w-[1600px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          
          {/* Left Block: Compliance, Location, Badging */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-ninpo-midnight rounded-xl border border-white/5 shadow-md">
              <Shield className="w-3.5 h-3.5 text-ninpo-lime" />
              <span className="text-[9px] font-black text-white uppercase tracking-widest">
                Verified Delivery
              </span>
            </div>
            
            <div>
              <div className="flex items-center gap-2 text-[9px] font-black text-slate-400 uppercase tracking-widest">
                <span>Detroit Area Hub</span>
                <span className="text-slate-700">•</span>
                <span className="text-slate-500">Compliance &amp; Guidance</span>
              </div>
              <p className="text-[8px] font-bold text-slate-600 leading-normal uppercase tracking-tight mt-1 max-w-xl">
                Ninpo Snacks operates in accordance with applicable beverage container deposit rules
                and local health guidance. See policies for details.
              </p>
            </div>
          </div>

          {/* Detroit Delivery Status Badge */}
          <div className="flex flex-col items-center justify-center mb-6 lg:mb-0 text-center">
            <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-[10px] font-black uppercase tracking-widest text-slate-300">
              <span className="w-2 h-2 rounded-full bg-ninpo-lime animate-pulse shadow-[0_0_8px_rgba(0,255,65,0.8)]" />
              <span>Detroit, MI · Personal Shopping · Open 24/7*</span>
            </div>
            <p className="text-[8px] font-semibold text-slate-500 mt-1">
              *Subject to store hours &amp; driver availability · Independent service; not affiliated with stores shopped.
            </p>
          </div>

          {/* Right Block: Standalone Page Navigation Links (Zero Modals) */}
          <nav aria-label="Legal and company links" className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[9px] font-black text-slate-400 uppercase tracking-widest">
            <Link
              to={FEATURE_ROUTES.legal.about}
              className="hover:text-ninpo-lime transition-colors"
            >
              About
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.howItWorks}
              className="hover:text-ninpo-lime transition-colors"
            >
              How It Works
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.customer.support}
              className="hover:text-ninpo-lime transition-colors"
            >
              Support
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.faq}
              className="hover:text-ninpo-lime transition-colors"
            >
              FAQ
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.terms}
              className="hover:text-ninpo-lime transition-colors"
            >
              Terms
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.privacy}
              className="hover:text-ninpo-lime transition-colors"
            >
              Privacy
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.refunds}
              className="hover:text-ninpo-lime transition-colors font-semibold"
            >
              Refunds
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.bottleReturns}
              className="hover:text-ninpo-lime transition-colors font-semibold"
            >
              Bottle Returns
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.legal.codeOfConduct}
              className="hover:text-ninpo-lime transition-colors font-semibold"
            >
              Support &amp; Conduct
            </Link>
            <span className="text-slate-700">•</span>
            <Link
              to={FEATURE_ROUTES.driver.onboarding}
              className="text-ninpo-lime hover:underline font-bold"
            >
              Drive with Us
            </Link>
          </nav>

        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
